import { render } from "./ViewMarchandPage.vue?vue&type=template&id=6f78a32d&ts=true"
import script from "./ViewMarchandPage.vue?vue&type=script&lang=ts"
export * from "./ViewMarchandPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__